/**
 * Spots the assistant's "connect your calendar" link to our own
 * /google-calendar page, so the web chat can show a connect button instead.
 * Matched on the path, not the host, so dev, prod and localhost all work.
 */

const CALENDAR_PAGE_PATH = '/google-calendar';

// The chat's URL regex (https?:\/\/[^\s]+) sweeps up sentence punctuation
const TRAILING_PUNCTUATION = /[.,!?;:)\]'"]+$/;

const URL_PATTERN = /https?:\/\/[^\s]+/g;

const stripTrailingPunctuation = (text) => text.replace(TRAILING_PUNCTUATION, '');

export function isGoogleCalendarPageLink(text) {
  if (typeof text !== 'string' || !text) return false;

  let url;
  try {
    url = new URL(stripTrailingPunctuation(text));
  } catch {
    return false;
  }

  if (url.protocol !== 'https:' && url.protocol !== 'http:') return false;
  return url.pathname.replace(/\/$/, '') === CALENDAR_PAGE_PATH;
}

// A pointer the assistant puts in front of the link ("👉 https://…"). Once the
// link is a button on its own line the pointer is left dangling, so it goes.
// 👉 (with any skin tone), 👇, 🔗, ➡️ and →, then spaces up to the link.
const POINTER_BEFORE_LINK = /(?:\u{1F449}[\u{1F3FB}-\u{1F3FF}]?|\u{1F447}[\u{1F3FB}-\u{1F3FF}]?|\u{1F517}|➡️?|→)[ \t]*$/u;

/** `text` (what comes right before the link) without a trailing pointer emoji. */
export function stripPointerBeforeLink(text) {
  if (typeof text !== 'string') return text;
  return text.replace(POINTER_BEFORE_LINK, '');
}

/** The first calendar page link in `text`, without trailing punctuation, or null. */
export function findGoogleCalendarPageLink(text) {
  if (typeof text !== 'string') return null;
  const match = (text.match(URL_PATTERN) || []).find(isGoogleCalendarPageLink);
  return match ? stripTrailingPunctuation(match) : null;
}
